import API from "shared/services/Api";
import { IOrthodonticElasticResponse } from "shared/types/OrthodonticElastic";

export const getOrthodonticElastics = async (
  userId: string
): Promise<IOrthodonticElasticResponse> =>
  API.get(`/oc/orthodontic-elastic?id=${userId}`);
